<template lang="pug">
  v-content.pa-0
    v-row(no-gutters)
      v-col(v-for='group in orderGroups' :key='group.name' cols='12' xs='12' sm='6' md='4' lg='3' xl='2')
        v-sheet(color='grey lighten-2')
          v-row(no-gutters)
            v-col(cols='12')
              .pl-3.pr-3
                div(style='float:left')
                  v-icon(small) mdi-plus-box-multiple
                  strong.pl-2 {{group.name}}: ({{group.orders.length}})
                div(v-if='group.isPrintable' style='float:right' @click='vibrate();printOrders(group.orders)')
                  v-icon(small) mdi-printer
                  strong Print
          v-divider
          e-z-order-list(:orders='group.orders' :options="{mode: 'track', seats:[]}") Loading...
</template>
<script>
import moment from "moment";
import { storeMixin } from "../../mixins/storeMixin.js";
import EZOrderList from "../shared/EZOrderList.vue";

export default {
  name: "eztrack",
  mixins: [storeMixin],
  components: { EZOrderList },
  data: () => ({
    collectionName: "orders",
    moment: moment
  }),
  computed: {
    orderGroups() {
      let groups = [
        {
          name: "On-counter",
          isPrintable: true,
          orders: this.serviceOrders.filter(
            o => o.status === this.STATUSES.QUEUED
          )
        }
      ];
      if (this.myFeatures.eligibleFeatures.includes("WORKFLOW")) {
        groups = [
          ...groups,
          ...[
            {
              name: "Prep-in-progress",
              orders: this.serviceOrders.filter(
                o => o.status === this.STATUSES.PREPON
              )
            },
            {
              name: "Ready to pick",
              orders: this.serviceOrders.filter(
                o => o.status === this.STATUSES.READY
              )
            },
            {
              name: "On the way to table",
              orders: this.serviceOrders.filter(
                o => o.status === this.STATUSES.INTRANSIT
              )
            },
            {
              name: "Served",
              orders: this.serviceOrders.filter(
                o => o.status === this.STATUSES.SERVED
              )
            }
          ]
        ];
      }
      groups.push({
        name: "Cleared",
        orders: this.serviceOrders.filter(
          o => o.status === this.STATUSES.CLEARED
        )
      });
      return groups;
    }
  },
  methods: {
    printOrders(orders) {
      //const maxCol = 32;
      let lines = [];
      orders.forEach(order => {
        lines.push("--------------------------------");
        lines.push(
          `Counter:${order.counterCode} Section:${order.sectionCode} Seat:${order.seat}`
        );
        lines.push(
          `Timestamp: ${moment(order.lastUpdatedTS || order.createdTS).format(
            "DD-MMM-YYYY LT"
          )}`
        );
        lines.push(
          `${order.productName.padEnd(25, " ")} Qty[${order.quantity}]`
        ); //max-6
        lines.push(
          `Custom: ${
            order.tags && order.tags.length ? order.tags.join(",") : "Standard"
          }`
        );
        lines.push("--------------------------------");
      });
      this.print(lines.join("\n                                \n"));
    }
  }
};
</script>